export default __webpack_public_path__ + "static/3-11-0-0-d15a905838266335bcd3a1083ad82103.jpg";